
export const BASEURL = 'http://localhost:8000/v1/';
